import { Card, ListGroup, Modal } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../store/reduxHooks';
import { useCallback, useRef, useState } from 'react';
import { resetProduct } from '../../store/product';
import { ProductCard } from '../../components/ProductCard/ProductCard';
import { OfferCard } from '../../components/OfferCard/OfferCard';
import './index.css';

export const ProductPageModal: React.FC = () => {
  const { product, shouldShowOffersModal } = useAppSelector(
    (state) => state.product
  );
  const dispatch = useAppDispatch();
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleCloseModal = useCallback(() => {
    dispatch(resetProduct());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (event.target === containerRef.current) {
      setIsDragging(true);
      setStartX(event.clientX - (containerRef.current?.offsetLeft ?? 0));
      setScrollLeft(containerRef.current?.scrollLeft ?? 0);
    }
  };

  const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (!isDragging) return;
    event.preventDefault();
    const x = event.clientX - (containerRef.current?.offsetLeft ?? 0);
    const scrollX = x - startX;
    if (containerRef.current !== null) {
      containerRef.current.scrollLeft = scrollLeft - scrollX;
    }
  };

  const handleMouseUp = (): void => {
    setIsDragging(false);
  };

  return (
    <Modal
      show={shouldShowOffersModal}
      onHide={handleCloseModal}
      dialogClassName="custom-dialog-style"
    >
      <Modal.Header closeButton>
        <Modal.Title>Информация о товаре</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="d-flex flex-column align-items-center overflow-y-auto"
        style={{ maxHeight: '80dvh' }}
      >
        {product !== null && <ProductCard product={product} />}
        {product?.offers !== undefined && product.offers.length > 0 && (
          <hr className="my-4 w-100" style={{ minHeight: '1px' }} />
        )}
        {product?.offers !== undefined && product.offers.length > 0 && (
          <Card>
            <Card.Body>
              <ListGroup className="list-group-flush">
                <ListGroup.Item>
                  Всего торговых предложений:{' '}
                  <strong>{product.offers.length}</strong>
                </ListGroup.Item>
                <ListGroup.Item>
                  <div className="d-flex w-100 gap-2 align-items-center">
                    <div
                      style={{
                        minWidth: '24px',
                        width: '24px',
                        height: '24px',
                        borderRadius: '10px',
                        backgroundColor: 'rgba(255,193,7)'
                      }}
                    />
                    <div>
                      <span>- нет в наличии</span>
                    </div>
                  </div>
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        )}
        {product?.offers !== undefined && product.offers.length > 0 && (
          <hr className="my-4 w-100" style={{ minHeight: '1px' }} />
        )}
        {product?.offers !== undefined && product.offers.length > 0 && (
          <div
            ref={containerRef}
            className="d-flex p-2 flex-row overflow-auto w-100"
            style={{
              gap: '1rem',
              minHeight: 'fit-content',
              cursor: isDragging ? 'grabbing' : 'grab'
            }}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
          >
            {product.offers.map((offer, index) => (
              <OfferCard key={index} offer={offer} />
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
